import React from 'react';
export function Begin() {
  return <section id="begin" className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto py-28 md:py-36 border-t border-ink/10" data-id="element-19" data-mp="193iktyawkdw3">
      <div className="max-w-2xl mx-auto text-center" data-id="element-20" data-mp="1akvwcp4jwps">
        <div className="label text-graphite/60 mb-10" data-id="element-21" data-mp="1b3487p2a1e2">Begin</div>
        <p className="font-sans font-light text-lg md:text-xl text-graphite/80 leading-relaxed" data-id="element-22" data-mp="6a7el1nq255z">
          You don't have to know which tier fits. Tell us where you are and
          what you're working toward, and we'll point you to the right place.
          When a seat opens, the waitlist hears first.
        </p>
        <a href="https://form.jotform.com/262155460714050" target="_blank" rel="noopener noreferrer" className="cta mt-12" data-id="element-23" data-mp="3eofvhcgvt7ib">
          Get in Touch
        </a>
      </div>
    </section>;
}